import moment from "moment";
import { mapGetters } from "vuex";
import generateForms from "@/data/functions/mixins/generateForms.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [generateForms, numberFunctions, generateID],
  computed: {
    ...mapGetters(["getUser", "getDetail", "getCurrentPage"]),
    defineDocumentLogMasterDocData() {
      let obj = {
        tag: "XXX", // orginal doc tag
        title: "", // original title
        idg: "", // original doc
        did: "", // original doc
        auth: null,
        heading1: "",
        heading2: "",
        description: "",
        btnIcon: true
      };
      if (this.getCurrentPage === "/userdash") {
        obj.tag = "U1";
        obj.btnIcon = false;
        obj.auth = true;
        obj.heading1 = this.getUser.basic.title;
        obj.heading2 = "User";
        obj.description = "Review activity completed by user or system.";
        obj.did = this.getUser.basic.did;
        obj.idg = this.getUser.basic.idg;
      } else if (this.getCurrentPage === "/companydash") {
        obj.tag = "C1";
        obj.btnIcon = false;
        obj.heading1 = this.getUser.pref.select.cname;
        obj.heading2 = "Company";
        if (this.getUser.pref.select.cauth === null) {
          obj.auth = false;
        } else {
          obj.auth = true;
        }
      } else if (this.getCurrentPage === "/facilitydash") {
        obj.tag = "F1";
        obj.btnIcon = false;
        obj.heading1 = this.getUser.pref.select.fname;
        obj.heading2 = "Facility";
        if (this.getUser.pref.select.fauth === null) {
          obj.auth = false;
        } else {
          obj.auth = true;
        }
      } else {
        obj.auth = true;
        obj.tag = this.getDetail.basic.tag;
        obj.heading1 = "heading 1";
        obj.heading2 = "heading 2";
        obj.did = this.getDetail.basic.did;
        obj.tag = this.getDetail.basic.tag;
        obj.idg = this.getDetail.basic.idg;
        obj.title = this.getDetail.basic.title;
        obj.description = "Review document activity log changes.";
      }
      return obj;
    }
  },
  methods: {
    prepareForDocumentLog() {
      // HELP
      // console.log("");
      // console.log(">>> PREP. FOR DOC. LOG <<<");
      // eslint-disable-next-line
      let page = this.defineDocumentLogMasterDocData;
      this.$store.dispatch("changePageInfo", page);
      // required for future load updates
      this.$store.dispatch("changeLogDID", page.did);
      // return tag
      return page.tag;
    },
    generateLog(logTag, noun, verb, docLog) {
      // HELP
      // console.log("");
      // console.log(">>> GENERATE DOC. LOG TEMPLATE <<<");
      // console.log("LOG TAG : " + logTag);
      // console.log("NOUN    : " + noun);
      // console.log("VERB    : " + verb);
      // console.log(docLog);

      // update local
      let tempLog = this.generateDocumentLogForm();

      // BASIC
      tempLog.basic.tag = "D3";
      // eslint-disable-next-line
      // SET data source
      const tag = "D3";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      tempLog.basic.did = did;
      tempLog.basic.idg = idg;
      tempLog.basic.title = "";
      tempLog.basic.act = true;
      tempLog.basic.lock = false;

      // Define Item
      const docTag = docLog.basic.tag;
      let itemId = ""; // id of document
      let itemIdg = ""; // idg of document
      let itemTitle = ""; // title of document
      let itemDid = ""; // did if document
      let itemTag = "";
      let itemTagd = ""; // used for access only
      let itemTags = ""; // used for access only

      if (logTag === "U1") {
        if (docTag !== "G1") {
          itemDid = docLog.basic.did;
          itemTitle = docLog.basic.title;
          itemIdg = docLog.basic.idg;
          itemId = docLog.basic.id;
          itemTag = docLog.basic.tag;
        } else {
          itemDid = docLog.char.did;
          itemTitle = docLog.char.title;
          itemIdg = docLog.char.idg;
          itemId = docLog.char.id;
          itemTag = docLog.char.tag;
        }
      } else {
        if (docTag === "G1") {
          itemTag = docLog.basic.tag;
          itemDid = docLog.char.udid;
          itemTitle = docLog.char.utitle;
          itemIdg = docLog.char.uidg;
          itemId = this.defineIDGShortLastSix(tempLog.basic.idg);
        } else if (
          docTag === "A1" ||
          docTag === "B1" ||
          docTag === "B3" ||
          docTag === "B4" ||
          docTag === "B6" ||
          docTag === "C1" ||
          docTag === "E1" ||
          docTag === "E2" ||
          docTag === "E6" ||
          docTag === "F1" ||
          docTag === "L1" ||
          docTag === "M2" ||
          docTag === "M5" ||
          docTag === "M7" ||
          docTag === "O1" ||
          docTag === "Q1" ||
          docTag === "S1" ||
          docTag === "S6" ||
          docTag === "W1" ||
          docTag === "W2" ||
          docTag === "W6"
        ) {
          itemTitle = docLog.basic.title;
          itemIdg = docLog.basic.idg;
          itemId = docLog.basic.id;
          itemTag = docLog.basic.tag;
          itemDid = docLog.basic.did;
        } else {
          itemDid = "NA";
          itemTitle = "NA";
          itemIdg = "NA";
          itemId = "NA";
          itemTag = "NA";
        }
      }
      // DEFINE Tags for Access
      if (docTag === "G1") {
        itemTag = docLog.basic.tag;
        itemTagd = docLog.basic.tagd;
        itemTags = docLog.basic.tags;
      }
      // ITEM under Change / Review
      tempLog.char.did = itemDid;
      tempLog.char.title = itemTitle;
      tempLog.char.idg = itemIdg;
      tempLog.char.id = itemId;
      tempLog.char.tag = itemTag;
      tempLog.char.tagd = itemTagd;
      tempLog.char.tags = itemTags;
      tempLog.char.cdid = this.getUser.pref.select.cdid;
      tempLog.char.fdid = this.getUser.pref.select.fdid;

      // CHAR
      tempLog.char.tnoun = noun;
      tempLog.char.tverb = verb;

      // REV (Copy REV from Master)
      tempLog.rev = docLog.rev;

      // STATS (who and when did this)
      tempLog.stats.dcrt = moment().format(); // revision date
      tempLog.stats.uname = this.getUser.basic.title;
      tempLog.stats.udid = this.getUser.basic.did;
      tempLog.stats.uemail = this.getUser.basic.email;
      tempLog.stats.uadmin = this.getUser.basic.admin;

      // console.log("");
      // console.log(">>> GENERATE DOCUMENT LOG <<<");
      // console.log(docLog);
      // console.log(tempLog);

      // Preload Store for later saving
      this.$store.dispatch("changeDocumentLog", tempLog);
      return tempLog;
    }
  }
};
